import { render, staticRenderFns } from "./JobSeekerFairModalForm.vue?vue&type=template&id=0a3c8ac9&"
import script from "./JobSeekerFairModalForm.vue?vue&type=script&lang=js&"
export * from "./JobSeekerFairModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobSeekerRequiredForm: require('/workspace/components/JobSeekerFair/JobSeekerRequiredForm.vue').default})
